import { Model } from './Model';
import { Money } from '../utilities';
import { Product } from '../models';
/**
 * Embedded value object for order ticket line items.
 * Not stored independently — lives as a nested array inside OrderTicket.
 * Extends Model only for $fill() deserialization; never inserted into the store.
 *
 * Money handling mirrors OrderItem: unit_price is a string in '0.0000'
 * format. All arithmetic goes through Money.parse(unit_price). The
 * string-on-the-wire contract is what the backend's
 * StoreManualOrderTicketRequest validator expects.
 */
export class OrderTicketItem extends Model {
    // Uses parent entity — this class is never stored independently.
    // Extends Model only for $fill() deserialization support.
    static entity = 'order_tickets';
    static primaryKey = 'external_id';
    external_id = '';
    name = '';
    quantity = 0;
    unit_price = '0.0000';
    // Snapshot of OrderItem.discount_percent at submit. unit_price stays the
    // pre-discount price; the discount is carried separately so the hub flow
    // fiscalizes the same discounted total as finishImmediately, with the
    // discount kept explicit on the receipt/reports.
    discount_percent = '0.00';
    attributes = [];
    product_id = null;
    static fields() {
        return {
            external_id: this.attr(''),
            name: this.attr(''),
            quantity: this.attr(0),
            unit_price: this.attr('0.0000', (value) => Money.parse(value ?? '0.0000').toFormat('0.0000')),
            discount_percent: this.attr('0.00', (value) => this.round(value, 2).toFixed(2)),
            attributes: this.attr([]),
            product_id: this.attr(null),
        };
    }
    constructor(record) {
        super();
        this.$fill(record);
    }
    isMapped() {
        return this.product_id !== null;
    }
    getMappedProduct() {
        if (!this.product_id)
            return undefined;
        return Product.find(this.product_id);
    }
}
export default OrderTicketItem;
//# sourceMappingURL=OrderTicketItem.js.map